import { ReportDetails } from 'model/constants';
import { IReportDeailState } from 'model/interfaces';
import { IReportsListResponse } from 'model/interfaces/reports-list';
import {
  AllPayGapsState,
  CategoryDataState,
  DropdownOptionState,
  HeadcountDistributionState,
  PayByGroupState,
  PayFactorListState,
  ReportMetaDataState,
} from 'model/types';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

const initialState = {
  isReportDetailsLoading: false,
  isAnnualOrHourly: ReportDetails.annual.toLowerCase(),
  reportInfo: null,
  reportMetaDataLoading: true,
  reportMetaData: null,
  tabName: '',
  activeTab: ReportDetails.orgOverview,
  activeTabs: [],
  groupOptions: ReportDetails.groupOptions,
  selectedGroup: null,
  isMedian: false,
  demographicsOption: '',
  demographyName: '',
  compTypeOptions: [],
  compType: ReportDetails.compTypeOptionEmpty,
  headcountDistributionLoading: true,
  headcountDistributionData: [],
  payByGroupLoading: true,
  payByGroupData: [],
  allPayGapsLoading: true,
  allPayGapsData: [],
  quartileCategoryLoading: true,
  quartileCategoryData: [],
  activeGapsTab: '',
  payFactors: [] as PayFactorListState[],
  countryTemplateData: null,
  orgOverviewGapAnalysis: {} as Record<string, number>,
};

export const useReportDeailStore = create<IReportDeailState>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        updateIsReportDetailsLoading: (isReportDetailsLoading: boolean) => set({ isReportDetailsLoading }),
        setIsAnnualOrHourly: (isAnnualOrHourly: string) => set({ isAnnualOrHourly }),
        updateReportInfo: (reportInfo: IReportsListResponse) => set({ reportInfo }),
        updateReportMetaDataLoading: (reportMetaDataLoading: boolean) =>
          set({ reportMetaDataLoading }),
        updateReportMetaData: (reportMetaData: ReportMetaDataState | null) => set({ reportMetaData }),
        updateTabName: (tabName: string) => set({ tabName }),
        updateActiveGapsTab: (activeGapsTab: string) => set({ activeGapsTab }),
        updateActiveTab: (activeTab: string) => set({ activeTab }),
        updateActiveTabsSequenceList: (activeTabs: string[]) => set({ activeTabs }),
        updateGroupOptions: (groupOptions: DropdownOptionState[]) => set({ groupOptions }),
        updateSelectedGroup: (selectedGroup: DropdownOptionState | null) => set({ selectedGroup }),
        updateIsMedian: (isMedian: boolean) => set({ isMedian }),
        updateDemographicsOption: (demographicsOption: string) => set({ demographicsOption }),
        updateDemographyName: (demographyName: string | number) => set({ demographyName }),
        updateCompTypeOptions: (compTypeOptions: DropdownOptionState[]) => set({ compTypeOptions }),
        updateCompType: (compType: DropdownOptionState) => set({ compType }),
        updateHeadcountDistributionLoading: (headcountDistributionLoading: boolean) =>
          set({ headcountDistributionLoading }),
        updateHeadcountDistributionData: (
          headcountDistributionData: HeadcountDistributionState[],
        ) => set({ headcountDistributionData }),
        updatePayByGroupLoading: (payByGroupLoading: boolean) => set({ payByGroupLoading }),
        updatePayByGroupData: (payByGroupData: PayByGroupState[]) => set({ payByGroupData }),
        updateAllPayGapsLoading: (allPayGapsLoading: boolean) => set({ allPayGapsLoading }),
        updateAllPayGapsData: (allPayGapsData: AllPayGapsState[]) => set({ allPayGapsData }),
        updateQuartileCategoryLoading: (quartileCategoryLoading: boolean) =>
          set({ quartileCategoryLoading }),
        updateQuartileCategoryData: (quartileCategoryData: CategoryDataState[]) =>
          set({ quartileCategoryData }),
        updatePayFactors: (payFactors: PayFactorListState[]) => set({ payFactors }),
        updateCountryTemplateData: (countryTemplateData: any) => set({ countryTemplateData }),
        updateOrgOverviewGapAnalysis: (orgOverviewGapAnalysis: Record<string, number>) =>
          set({ orgOverviewGapAnalysis }),
        resetReportDetailsData: () => set({ ...initialState }),
      }),
      {
        name: 'kf1-reportDetailStore', // Key name in sessionStorage
        storage: createJSONStorage((): Storage => window.sessionStorage), // Persist to sessionStorage
      },
    ),
  ),
);
